import React from 'react';

import axios from 'axios';

import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';

import NavComponent from './Component/NavComponent';
import BannerComponent from '../Shared/Component/BannerComponent';
import DialogComponent from '../Shared/Component/DialogComponent';

import { Config } from '../../Config';

class Shared extends React.Component {
    constructor() {
        super()
        this.state = {
            view: true,

            idx: 0,

            data: [],

            dialog: false,
        }
    }

    tick() {
        this.setState({ view: !this.state.view })

        if (this.state.view === true) {
            if (this.state.idx < this.state.data.length - 1) {
                this.setState({ idx: this.state.idx + 1 })
            }
            else {
                this.setState({ idx: 0 })
            }
        }
    }

    componentDidMount() {
        this.fetchData()
        this.interval = setInterval(() => this.tick(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    fetchData = () => {
        axios.get(Config() + '/common/get/banner')
        .then(response => {
            if (response.data[0] === "OK") {
                this.setState({ data: response.data[1] })
            }
        })
        .catch(error => {
            console.log(error)
        })
    }

    render() {
        return (
            <React.Fragment>
                <NavComponent action={this.props.action} />

                <BannerComponent data={this.state.data} idx={this.state.idx}
                    view={this.state.view} />

                <DialogComponent dialog={this.state.dialog}
                    action={this.props.action2} />

                <br />
                
                <CssBaseline />
                <Divider />

                <br />
            </React.Fragment>
        )
    }
}

export default Shared;